import { createSelector } from 'reselect';

// Basic selectors
const selectConnectors = (state) => state.entities.connectors;

export const selectConnectorById = createSelector(
  selectConnectors,
  (_, connectorId) => connectorId,
  (connectors, connectorId) => connectors[connectorId]
);
